// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"84a1389d","239":"11be2757","453":"951869e1","732":"e805c022"}[chunkId] + ".chunk.js";
};